import React from 'react';
import { FadeIn } from './FadeIn';
export function PromiseSection() {
  const promises = [{
    emoji: '🥗',
    text: '32 recetas fáciles para comer más ligero sin aburrirte ni cocinar complicado'
  }, {
    emoji: '🍽️',
    text: 'Guía práctica para pedir mejor en restaurantes sin sentir que pierdes el control'
  }, {
    emoji: '🥂',
    text: 'Estrategias reales para fiestas, alcohol y fines de semana sin sabotear tu progreso'
  }, {
    emoji: '🔄',
    text: 'Sustituciones inteligentes que reducen calorías sin eliminar el sabor'
  }, {
    emoji: '✨',
    text: 'Un sistema que se adapta a tu vida social, no al revés'
  }];
  return <section className="py-20 bg-warm-beige/20 border-b border-gray-100" data-id="element-256">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-257">
        <FadeIn data-id="element-258">
          <div className="text-center mb-16" data-id="element-259">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-warm-brown mb-6" data-id="element-260">
              Con Sabores que Adelgazan aprenderás a:
            </h2>
            <div className="w-24 h-1 bg-olive-green mx-auto rounded-full" data-id="element-261"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-262">
          {promises.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === promises.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''} data-id="element-263">
              <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow h-full flex items-start border border-warm-beige/50" data-id="element-264">
                <div className="text-4xl mr-5 shrink-0" data-id="element-265">{item.emoji}</div>
                <p className="text-lg font-medium text-gray-800 leading-relaxed pt-1" data-id="element-266">
                  {item.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}